import React from 'react';

const defaultState = {
  IAMAuthorizer: () => {},
};

const IAMContext = React.createContext(defaultState);
export default IAMContext;
